import { useContext, useEffect } from 'react'
import { DEFAULT_VIEW_STATE_SCOPE } from '../constants'
import { ViewStateContext } from '../context'
import type { Scope } from '../types'

const useViewStateScopeInternal = (
  scope: Scope | undefined = undefined,
): Scope | undefined => {
  const ctxScope = useContext(ViewStateContext)
  return scope ?? ctxScope?.scope
}

/**
 * Find the correct scope for the current context.
 * Given scope will override context scope if provided.
 */
export const useViewStateScope = (
  scope: Scope | undefined = undefined,
): Scope => {
  const actualScope = useViewStateScopeInternal(scope)
  const hasActualScope = Boolean(actualScope)

  // Only show once to stop spamming and causing performance issues
  useEffect(() => {
    if (!hasActualScope) {
      console.warn('no view state scope available. using default')
    }
  }, [])

  return actualScope ?? DEFAULT_VIEW_STATE_SCOPE
}
